import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';


import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { Helper } from '../../../../../utils/helper';
import {
  HeadingInitModel, HeadingInitVariables,
  HeadingModel,
  HeadingVariables,
} from '../../../../../models/email-template/heading.interface';

@Component({
    selector: 'app-heading',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './heading.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './heading.component.scss'
})
export class HeadingComponent extends BaseComponent implements OnInit {
  @Input() block: HeadingModel = new HeadingInitModel();
  @Input() isPreview = false;
  count: number = 0;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new HeadingInitVariables()
    }
  }

  //placeholders:
  headingPlaceholder: string = 'Enter Heading Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof HeadingVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
